const config = [
  {
    itemId: '1',
    subItems: {
      count: 1,
      subSubItems: null
    }
  },
  {
    itemId: '2',
    subItems: {
      count: 5,
      subSubItems: null
    }
  },
  {
    itemId: '3',
    subItems: {
      count: 6,
      subSubItems: null
    }
  },
  {
    itemId: '4',
    subItems: {
      count: 7,
      subSubItems: {
        forSubItem: 7,
        count: 5
      }
    }
  },
  {
    itemId: '5',
    subItems: {
      count: 3,
      subSubItems: null
    }
  },
  {
    itemId: '6',
    subItems: {
      count: 3,
      subSubItems: null
    }
  },
  {
    itemId: '7',
    subItems: {
      count: 3,
      subSubItems: null
    }
  },
  {
    itemId: '8',
    subItems: {
      count: 5,
      subSubItems: null
    }
  },
  {
    itemId: '9',
    subItems: {
      count: 2,
      subSubItems: null
    }
  },
  {
    itemId: '10',
    subItems: {
      count: 8,
      subSubItems: null
    }
  },
  {
    itemId: '11',
    subItems: {
      count: 2,
      subSubItems: null
    }
  },
  {
    itemId: '12',
    subItems: {
      count: 5,
      subSubItems: null
    }
  },
  {
    itemId: '13',
    subItems: {
      count: 2,
      subSubItems: null
    }
  },
  {
    itemId: '14',
    subItems: {
      count: 7,
      subSubItems: null
    }
  },
  {
    itemId: '15',
    subItems: {
      count: 4,
      subSubItems: null
    }
  },
  {
    itemId: '16',
    subItems: {
      count: 2,
      subSubItems: null
    }
  }
];

export default config;
